module.exports = __webpack_public_path__ + "static/media/video.096a9cc0.svg";